import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { TranslateService } from '@ngx-translate/core';
import {
  isPlatform,
  LoadingController,
  ToastController,
  AlertController,
  NavController,
} from '@ionic/angular';
import { Router } from '@angular/router';
import { ClientService } from './client/client/client.service';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root',
})
export class UiService {
  loaderInstance: any;
  reloadCount: number = 0;
  constructor(
    private loadingController: LoadingController,
    private toastController: ToastController,
    private swUpdates: SwUpdate,
    private alertController: AlertController,
    private translate: TranslateService,
    private router: Router,
    private navCtrl: NavController,
    private clientService: ClientService
  ) {}

  async initLoader(msg?: string) {
    const loadingText: string =
      this.translate.instant('alert.global_loader.loading') || 'Loading...';
    this.loaderInstance = await this.loadingController.create({
      cssClass: 'tx-loader',
      message: msg || loadingText,
      showBackdrop: true,
      mode: isPlatform('ios') ? 'ios' : 'md',
      translucent: false,
    });
    await this.loaderInstance.present();
  }

  async presentGlobalLoading(msg?: string) {
    const loadingText: string =
      this.translate.instant('alert.global_loader.loading') || 'Loading...';
    const loading = await this.loadingController.create({
      cssClass: 'tx-loader',
      message: msg || loadingText,
      showBackdrop: true,
      mode: isPlatform('ios') ? 'ios' : 'md',
      translucent: false,
    });
    await loading.present();
    return loading;
  }

  async dismissGlobalLoading() {
    try {
      await this.loadingController.dismiss();
    } catch (e) {
    }
  }

  async presentToast(msg?: string, position?: any, duration?: number) {
    const errorMessage: string = this.translate.instant(
      'alert.present_toast.error_message'
    );
    const toast = await this.toastController.create({
      message: msg || errorMessage,
      position: position || 'top',
      duration: duration || 2000,
      cssClass: 'tx-toast',
      mode: isPlatform('ios') ? 'ios' : 'md',
    });
    toast.present();
  }

  /** Soft duty-free themed toast (copy feedback, empty states, soft confirms). */
  async presentDutyfreeToast(
    msg?: string,
    position?: any,
    duration?: number,
    icon = 'checkmark-circle'
  ) {
    const errorMessage: string = this.translate.instant(
      'alert.present_toast.error_message'
    );
    const toast = await this.toastController.create({
      message: msg || errorMessage,
      position: position || 'top',
      duration: duration || 2000,
      cssClass: 'df-toast',
      icon,
      mode: isPlatform('ios') ? 'ios' : 'md',
    });
    return toast.present();
  }

  async showUpdateToast() {
    const updateToast: any = this.translate.instant('alert.update_toast');
    const toast = await this.toastController.create({
      header: updateToast.new_updates,
      position: 'top',
      translucent: true,
      cssClass: 'update-available-toast',
      buttons: [
        {
          text: updateToast.update,
          handler: () => {
            this.swUpdates
              .activateUpdate()
              .then(() => document.location.reload());
          },
          // }, {
          //   icon: 'close',
          //   role: 'cancel',
          //   handler: () => {
          //   }
        },
      ],
    });
    toast.present();
  }

  async presentModal(msg: string, handler = () => {}, buttonCaptions = '') {
    const benefitsExhausted: any = this.translate.instant(
      'alert.present_modal.benefits_exhausted'
    );
    const alert = await this.alertController.create({
      header: msg || benefitsExhausted,
      cssClass: 'generic-alert',
      buttons: [
        {
          text: buttonCaptions || 'OK',
          role: 'confirm',
          handler,
        },
      ],
    });

    return await alert.present();
  }

  reloadPage(reloadUrl?: string, hardReload?: boolean) {
    if (hardReload && Capacitor.getPlatform() == 'web') {
      // Force reload for web platform - update this code to handle web and app flags coming from caller
      window.location.reload();
      return;
    }
    const url = reloadUrl || this.router.url;
    this.navCtrl
      .navigateForward(`/blank`, {
        skipLocationChange: true,
        animated: false,
      })
      .then(() => {
        this.navCtrl.navigateForward(`/${url}`, { animated: false });
      });
  }

  //AutoCheckout
  async presentDutyfreeLoading(msg?: string) {
    const loading = await this.loadingController.create({
      message: msg,
      cssClass: 'dutyfree-loader',
      showBackdrop: true,
      spinner: null,
      mode: isPlatform('ios') ? 'ios' : 'md',
    });
    await loading.present();
    return loading;
  }
}
